(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ruby-mobile-buy-bar"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ruby-mobile-buy-bar')) {
    customElements.define('ruby-mobile-buy-bar', class extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        this.mainButton = document.getElementById(`ProductSubmitButton-${this.dataset.section}`);
        this.productInfo = document.getElementById(`MainProduct-${this.dataset.section}`);
        this.button = this.querySelector('button');
        if (!this.mainButton || !this.productInfo) return;
        this.sync = () => {
          this.button.disabled = this.mainButton.disabled || this.mainButton.getAttribute('aria-disabled') === 'true';
          const label = this.mainButton.querySelector('span');
          if (label) this.button.textContent = label.textContent.trim();
          const price = document.getElementById(`price-${this.dataset.section}`);
          const amount = price?.querySelector('.price--on-sale .price-item--sale') || price?.querySelector('.price-item--regular');
          const stickyPrice = this.querySelector('[data-sticky-price]');
          const showPrice = Boolean(amount && !price.hidden && !price.classList.contains('hidden'));
          stickyPrice.hidden = !showPrice;
          stickyPrice.textContent = showPrice ? amount.textContent.trim() : '';
          const activeImage = this.productInfo.querySelector('.product__media-item.is-active img');
          const thumbnail = this.querySelector('img');
          if (activeImage && thumbnail && thumbnail.src !== activeImage.currentSrc) {
            thumbnail.removeAttribute('srcset');
            thumbnail.src = activeImage.currentSrc;
          }
        };
        this.button.addEventListener('click', () => {
          this.sync();
          if (!this.button.disabled) {
            this.mainButton.click();
            this.sync();
          }
        }, { signal: this.controller.signal });
        this.nativeButtonPassed = false;
        this.footerVisible = false;
        this.updateVisibility = () => {
          this.nativeButtonPassed = this.mainButton.getBoundingClientRect().bottom <= 0;
          const footerRect = document.querySelector('footer')?.getBoundingClientRect();
          this.footerVisible = Boolean(footerRect && footerRect.top < window.innerHeight && footerRect.bottom > 0);
          this.hidden = !this.nativeButtonPassed || this.footerVisible;
        };
        this.scheduleVisibility = () => {
          if (this.visibilityFrame) return;
          this.visibilityFrame = requestAnimationFrame(() => {
            this.visibilityFrame = null;
            this.updateVisibility();
          });
        };
        window.addEventListener('scroll', this.scheduleVisibility, { passive: true, signal: this.controller.signal });
        window.addEventListener('resize', this.scheduleVisibility, { passive: true, signal: this.controller.signal });
        this.observer = new IntersectionObserver(([entry]) => {
          this.nativeButtonPassed = !entry.isIntersecting && entry.boundingClientRect.bottom <= 0;
          this.updateVisibility();
        });
        this.observer.observe(this.mainButton);
        this.footerObserver = new IntersectionObserver(([entry]) => {
          this.footerVisible = entry.isIntersecting;
          this.updateVisibility();
        });
        const footer = document.querySelector('footer');
        if (footer) this.footerObserver.observe(footer);
        this.sizeObserver = new ResizeObserver(() => {
          const height = this.getBoundingClientRect().height;
          if (height > 0 && !this.hidden) document.body.style.setProperty('--ruby-buy-bar-space', `${Math.ceil(height) + 16}px`);
        });
        this.sizeObserver.observe(this);
        this.mutations = new MutationObserver((records) => {
          if (records.some(record => !this.contains(record.target))) this.sync();
        });
        this.mutations.observe(this.productInfo, { subtree: true, childList: true, attributes: true, characterData: true });
        this.sync();
        this.updateVisibility();
      }
      disconnectedCallback() {
        this.controller?.abort();
        if (this.visibilityFrame) cancelAnimationFrame(this.visibilityFrame);
        this.observer?.disconnect();
        this.mutations?.disconnect();
        this.footerObserver?.disconnect();
        this.sizeObserver?.disconnect();
        document.body.style.removeProperty('--ruby-buy-bar-space');
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ruby-tallit-size-guide"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ruby-size-guide')) customElements.define('ruby-size-guide', class extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      const options = { signal:this.abort.signal }, dialog = this.querySelector('dialog'), opener = this.querySelector('.ruby-size-guide__open');
      opener.addEventListener('click', () => dialog.showModal(), options);
      this.querySelector('[data-guide-close]').addEventListener('click', () => dialog.close(), options);
      dialog.addEventListener('click', event => {
        const rect = dialog.getBoundingClientRect();
        if (event.target === dialog && (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom)) dialog.close();
      }, options);
      dialog.addEventListener('close', () => opener.focus(), options);
    }
    disconnectedCallback() { this.abort?.abort(); }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ruby-variant-facts"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('ruby-variant-facts')){
 customElements.define('ruby-variant-facts',class extends HTMLElement{
  connectedCallback(){
   this.info=this.closest('product-info');if(!this.info)return;
   this.sync=()=>{
    const data=this.info.querySelector('variant-selects [data-selected-variant]');
    let variant;try{variant=JSON.parse(data?.textContent||'null')}catch{return}if(!variant)return;
    this.querySelectorAll('[data-option-index]').forEach(cell=>{const value=variant.options[Number(cell.dataset.optionIndex)]||'';if(cell.textContent!==value)cell.textContent=value});
    const availability=this.querySelector('[data-fact-availability]');if(availability){const value=variant.available?this.dataset.available:this.dataset.unavailable;if(availability.textContent!==value)availability.textContent=value}
    const sku=this.querySelector('[data-fact-sku]');if(sku&&sku.textContent!==(variant.sku||''))sku.textContent=variant.sku||'';
    const amount=this.info.querySelector('.price--on-sale .price-item--sale')||this.info.querySelector('.price-item--regular');
    const price=this.querySelector('[data-fact-price]');if(amount&&price&&price.textContent!==amount.textContent.trim())price.textContent=amount.textContent.trim();
   };
   this.observer=new MutationObserver(records=>{if(records.some(record=>!this.contains(record.target)))this.sync()});
   this.observer.observe(this.info,{childList:true,subtree:true,characterData:true});this.sync();
  }
  disconnectedCallback(){this.observer?.disconnect()}
 });
}
  } catch(e) { console.error(e); }
})();

})();
